// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___3pC22","form-container":"styles__form-container___2kLc-","label-title":"styles__label-title___1EGFd","button":"styles__button___3A8Df"};